import { GET_TRIAGE_POLICIES } from '../../constants/actions/policies';

export function getTriagePolicies(payload) {
    return {
        type: GET_TRIAGE_POLICIES,
        payload,
    };
}
